import React, { useEffect, useState } from 'react';
import { Grid, InputAdornment, Typography } from '@material-ui/core';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-pro/css/all.css';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';

import { AppArea, AppIcon, AppName, Item, NoAppArea, NoAppDesc, NoAppTitle, SearchBar, Title, ImgArea, AppTitle, AppHint, AppDesc } from './style';
import { CommonButton } from '../common/Buttons';
import { authTableau } from '../../actions/TableauAuth'
import { addFavoriteApp, getApps, getFavoriteApps, removeFavoriteApp } from '../../actions/FavoriteApps';
import { openToast } from '../../actions/System';

import appImage from '../../assets/img/appExample.png';
import { StyledSearchAdornment } from '../Header/style';
import { store } from '../../states/index';

const FavoritesApp = () => {
  const dispatch = useDispatch();
  const [filteredElements, setFilteredElements] = useState('');
  const [appData, setAppData] = useState({});
  const [alreadyFavorite, setAlreadyFavorite] = useState(false);

  const { apps, cpf, favoriteApps, id } = useSelector(({ apps, auth }) => ({
    apps: apps?.apps || [],
    favoriteApps: apps?.favoriteApps || [],
    cpf: auth?.userData?.cpf || null,
    id: auth?.userData?.userLogado?.id || null
  }));

  useEffect(() => {
    loadApps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFilteredElements(apps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favoriteApps]);

  const searchApps = (value) => {
    if (apps.length && value.length) {
      const newValue = value.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
      const cleanValue = newValue.replace(/[-[/\]{}()*+?.,\\^$|#]/g, '');
      const searchRegex = new RegExp(`${cleanValue.toUpperCase()}`, 'gi');
      const searchedItens = apps.filter(({ appName }) => {
        const newAppName = appName.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        return newAppName.toUpperCase().match(searchRegex);
      });

      if (!searchRegex) setFilteredElements(apps);
      else setFilteredElements(searchedItens);
    } else if (value === '') {
      setFilteredElements(apps)
    }
  };

  const loadApps = async () => {
    try {
      await dispatch(await getApps());
      await dispatch(await getFavoriteApps(cpf));
    } catch (error) {
      dispatch(openToast('Erro ao Carregar Dados'));
    }
  };

  const AppItem = ({ data: { id, appName, hint, description, icon = 'fa-car-side', url, thumbnail } }) => {
    const validate = appName && icon && icon !== 'Faltando' && url.match('http');
    return (
      validate && (
        <Grid item md={3} xs={4} onClick={() => handleClick({ appName, hint, description, url, id, thumbnail })}>
          <Item>
            <AppIcon className={`${icon}`}></AppIcon>
            <AppName>{appName}</AppName>
          </Item>
        </Grid>
      )
    );
  };

  const handleClick = (i) => {
    setAppData(i);
    const isFavorite = favoriteApps.filter((favoriteApps) => favoriteApps.id === i.id);
    setAlreadyFavorite(isFavorite?.length ? true : false);
  };

  const handleAddFav = async (user_id, app_id) => {
    try {
      await dispatch(await addFavoriteApp({ user_id, app_id }));
    } catch (error) {
      dispatch(openToast('Erro ao Adicionar Favorito'));
    } finally {
      reset();
    }
  };

  const handleRemoveFav = async (user_id, app_id) => {
    try {
      await dispatch(await removeFavoriteApp({ user_id, app_id }));
    } catch (error) {
      dispatch(openToast('Erro ao Remover Favorito'));
    } finally {
      reset();
    }
  };

  const openWindown = async (appData, cpf) => {
    try {
      let url = appData?.url;
      if (appData.hint === 'tableau') {
        await dispatch(authTableau(cpf));
        const state = store.getState();
        const token = state.tableau.tableau
        url = `${appData?.url}/${token}`
      }
      
      window.open(url, '_blank')

    } catch (error) {
      console.warn(error)
    }

  };

  const reset = () => {
    loadApps();
    setAppData();
  };

  return (
    <Grid container spacing={2} style={{ padding: '0 10px' }}>
      <Grid item lg={6} md={12} sm={12} xs={12}>
        <Grid container style={{ display: 'flex', alignItems: 'center' }}>
          <Grid item sm={12}>
            <Title>{'Aplicativos Favoritos'}</Title>
          </Grid>
        </Grid>
        <SearchBar
          fullWidth
          placeholder={'Digite aqui para pesquisar acessos'}
          onChange={({ target: { value } }) => searchApps(value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                <StyledSearchAdornment icon={faSearch} />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
        {favoriteApps.length ? (<Typography style={{ marginTop: 10 }}>Meus Favoritos</Typography>) : null}
        <AppArea container spacing={2}>
          {favoriteApps.length ? (
            favoriteApps?.map((i, index) => {
              return <AppItem key={index} data={i} />;
            })
          ) : null}
        </AppArea>

        <Typography style={{ marginTop: 10 }}>Todos os Aplicativos</Typography>
        <AppArea container spacing={2}>
          {filteredElements.length ? (
            filteredElements?.map((i, index) => {
              return <AppItem key={index} data={i} />;
            })
          ) : (
            <Typography>Não foram encontrados Aplicativos</Typography>
          )}
        </AppArea>

      </Grid>
      <NoAppArea selected={appData?.appName ? true : false} item lg={6} md={12} sm={12} xs={12}>
        {!appData?.appName ? (
          <>
            <NoAppTitle variant="h2">
              Escolha um <br /> acesso favorito
            </NoAppTitle>
            <NoAppDesc>(se voce não tiver nenhum, basta pesquisar e favoritar)</NoAppDesc>
          </>
        ) : (
          <>
            <ImgArea>
              <img src={appData?.thumbnail || appImage} alt="Imagem referente ao aplicativo selecionado" />
            </ImgArea>
            <AppTitle>{appData?.appName}</AppTitle>
            <AppHint>{appData?.hint}</AppHint>
            <AppDesc>{appData?.description}</AppDesc>
            <Grid container spacing={4}>
              <Grid item sm={3} xs={6}> 
                <CommonButton label="Acessar" action={() => openWindown(appData, cpf)} />
              </Grid>
              <Grid item sm={3} xs={6}>
                <CommonButton
                  action={() => {
                    alreadyFavorite ? handleRemoveFav(id, appData?.id) : handleAddFav(id, appData?.id);
                  }}
                  fontColor="black"
                  color="#e9e9e9"
                  label={alreadyFavorite ? 'Remover' : 'Favoritar'}
                />
              </Grid>
            </Grid>
          </>
        )}
      </NoAppArea>
    </Grid>
  );
};

export default FavoritesApp;
